import { FaFacebookF, FaInstagram, FaLinkedin   } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";

export default function Footer(props) {
    return (
        <div className="bg-blue-800 p-4 mt-auto sm:p-6 xl:p-8 text-blue-200 flex flex-col md:flex-row gap-4 justify-between items-center">
            <div>
                &copy; Valuations Africa. All Rights Reserved.
            </div>

            <div className={"flex gap-4"}>
                <a href={"#"} className={"hover:text-white cursor-pointer p-2"}><FaFacebookF /> </a>
                <a href={"#"} className={"hover:text-white cursor-pointer p-2"}><FaXTwitter /> </a>
                <a href={"#"} className={"hover:text-white cursor-pointer p-2"}><FaInstagram /> </a>
                <a href={"#"} className={"hover:text-white cursor-pointer p-2"}><FaLinkedin /> </a>
                <a href={"#"} className={"hover:text-white cursor-pointer p-2"}><MdEmail /> </a>
            </div>
        </div>
    )
}